import {IconGoTo} from "@bounce/shared/ui";
import {prettifyCurrency} from "@bounce/shared/helpers";
import {BundleAccountInfo} from "@bounce/shared/consumer/declarations";
import {Container} from "./Container";
import {Text} from "./Text";
import {colors, radii, spacing} from "~/new-design/theme";
import {withStopPropagation} from "~/new-design/utils";
import CompanyLogo from "~/components/bundle/CompanyLogo";

type BundleBalancesListProps = {
  accounts: BundleAccountInfo[];
  onAccountClick: (accountId: string) => void;
};

export const BundleBalancesList = ({accounts, onAccountClick}: BundleBalancesListProps) => (
  <Container fullWidth gap={1}>
    {accounts.map((account) => (
      <Container
        key={account.account_id}
        fullWidth
        row
        gap={2}
        onClick={withStopPropagation(() => onAccountClick(String(account.account_id)))}
        sx={{
          alignItems: "center",
          justifyContent: "space-between",
          padding: spacing[2],
          border: `1px solid ${colors.tertiary[300]}`,
          borderRadius: radii.xs,
          "&:hover": {backgroundColor: colors.tertiary[100]},
        }}
      >
        <Container row gap={2} sx={{alignItems: "center", minWidth: 0}}>
          <CompanyLogo companyName={account.product} />
          <Container gap={0} sx={{minWidth: 0}}>
            <Text variant="body-semibold" color={colors.grey[800]}>
              {account.product}
            </Text>
            <Text variant="caption" color={colors.grey[700]}>
              {`Issued by ${account.original_creditor}`}
            </Text>
          </Container>
        </Container>
        <Container row gap={1.5} sx={{alignItems: "center", flexShrink: 0}}>
          <Text variant="display-body" color={colors.grey[1000]}>
            {prettifyCurrency(account.total_amount)}
          </Text>
          <IconGoTo width={16} height={16} />
        </Container>
      </Container>
    ))}
  </Container>
);
